import React from 'react';

import Select from 'react-select';

export default function SelectField({
    onChange,
    options,
    value,
    className,
    isDisabled = false,
    isGrouped = false,
    isMulti = false,
    isLoading = false,
    clearable = false,
    backgroundColor = 'white',
    height = 36,
    placeholder,
    styles,
    menuPortalTarget = document.body,
    formatOptionLabel,
    inputId,
}) {
    const groupStyles = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    };

    const groupBadgeStyles = {
        backgroundColor: '#EBECF0',
        borderRadius: '2em',
        color: '#172B4D',
        display: 'inline-block',
        fontSize: 12,
        fontWeight: 'normal',
        lineHeight: '1',
        minWidth: 1,
        padding: '0.16666666666667em 0.5em',
        textAlign: 'center',
    };

    // A group with no label (e.g. a leading group of one standalone option) gets no heading.
    const formatGroupLabel = (data) =>
        !data.label && !data.groupLabel ? null : (
            <>
                {!!data.groupLabel && (
                    <div style={groupStyles}>
                        <span>{data.groupLabel}</span>
                    </div>
                )}
                <div style={groupStyles}>
                    <span>{data.label}</span>
                    <span style={groupBadgeStyles}>{data.options.length}</span>
                </div>
            </>
        );

    const defaultValue = (options, value) => {
        if (isMulti) {
            if (!Array.isArray(value)) return [];
            if (isGrouped) {
                const allOptions = options.flatMap((group) => group.options);
                return allOptions.filter((option) => value.includes(option.value));
            }
            return options ? options.filter((option) => value.includes(option.value)) : [];
        }
        if (isGrouped) {
            let selectedOption = '';
            options.forEach((group) => {
                const currentGroupSelectedOption = group.options.find((option) => option.value == value);
                if (currentGroupSelectedOption) {
                    selectedOption = currentGroupSelectedOption;
                }
            });
            return selectedOption;
        }
        return options ? options.find((option) => option.value == value) : '';
    };
    return (
        <div className={className}>
            <Select
                placeholder={placeholder}
                inputId={inputId}
                isDisabled={isDisabled}
                isClearable={clearable}
                isMulti={isMulti}
                isLoading={isLoading}
                value={defaultValue(options, value)}
                onChange={(value) => onChange(value)}
                options={options}
                menuPortalTarget={menuPortalTarget}
                styles={{
                    control: (baseStyles, state) => ({
                        ...baseStyles,
                        minHeight: height,
                        ...(isMulti ? {} : { height: height }),
                        backgroundColor: backgroundColor,
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    valueContainer: (provided, state) => ({
                        ...provided,
                        minHeight: height,
                        ...(isMulti ? { flexWrap: 'wrap' } : { height: height }),
                        padding: '0 6px',
                    }),
                    input: (provided, state) => ({
                        ...provided,
                        margin: '0px',
                    }),
                    indicatorsContainer: (provided, state) => ({
                        ...provided,
                        height: height,
                    }),
                    ...styles,
                }}
                className="react-select-container"
                classNamePrefix="react-select"
                formatGroupLabel={formatGroupLabel}
                formatOptionLabel={formatOptionLabel}
            />
        </div>
    );
}
